import LoginPage from "./pages/v2/login.vue";
import privacyFallback from "./pages/v2/privacyFallback.vue";
import termsOfService from "./pages/v2/termsOfService.vue";
import termsOfServiceFallback from "./pages/v2/termsOfServiceFallback.vue";
import skbRegister from "./pages/v2/sbk/skbRegister";
import ActivationPage from "./pages/v2/sbk/activate";
import PasswordReset from "./pages/v2/sbk/passwordReset.vue";
import PasswordResetSet from "./pages/v2/sbk/passwordResetSet.vue";
import SbkRegisterSuccessPage from "./pages/v2/sbk/skbRegisterSuccess.vue";
import SbkLogin from "./pages/v2/sbk/sbkLogin.vue";
import Maintenance from "./pages/v2/maintenance.vue";
import SbkSite from "./pages/v2/sbk/sbkSite.vue";
import PlaygroundPage from "./pages/v2/playgroundPage.vue";
import FeedPage from "./pages/v2/feed/feedPage.vue";
import ArticlesPage from "./pages/v2/articlesPage.vue";
import ChallengePage from "./pages/v2/challenge/challengePage.vue";
import CustomChallengeDetailPage from "./pages/v2/challenge/customChallengeDetailPage.vue";
import CompetitiveChallengeDetailPage from "./pages/v2/challenge/competitiveChallengeDetailPage.vue";
import statisticsPage from "./pages/v2/challenge/statisticsPage.vue";
import ArticlePage from "./pages/v2/feed/articlePage.vue";
import CompetitiveChallengeJoinTeamPage from "./pages/v2/challenge/CompetitiveChallengeJoinTeamPage.vue";
import FavoritePage from "./pages/v2/feed/favoritePage.vue";
import LockedScreenPage from "./pages/v2/lockedScreenPage.vue";
import SettingsPage from "./pages/v2/settingsPage.vue";
import PrivacyPage from "./pages/v2/privacyPage.vue";
import ImprintPage from "./pages/v2/imprintPage.vue";
import ContactPage from "./pages/v2/contactPage.vue";
import HistoryPage from "./pages/v2/challenge/historyPage.vue";

const routes = [
  {
    name: "root",
    path: "/",
    components: {
      default: LoginPage,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "slugRoot",
    path: "/:slug",
    components: {
      default: LoginPage,
    },
    meta: {
      hideNavigation: false,
      isPublic: true,
    },
  },
  {
    path: "/:slug/login",
    components: { default: LoginPage },
    name: "slugLogin",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
  },
  {
    path: "/login",
    components: { default: LoginPage },
    name: "login",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
  },
  {
    path: "/:slug/register",
    components: { default: LoginPage },
    name: "slugRegister",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
  },
  {
    path: "/register",
    components: { default: LoginPage },
    name: "register",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
  },
  {
    path: "/desktop-deactivated",
    components: { default: LoginPage },
    name: "desktopVersionDeactivated",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
  },
  {
    name: "sbkRegister",
    path: "/sbk/register/:atmCampaign",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: skbRegister,
    },
  },
  {
    name: "sbkRegisterSuccess",
    path: "/sbk/register/:atmCampaign/success",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: SbkRegisterSuccessPage,
    },
  },
  {
    name: "sbkActivate",
    path: "/sbk/activate/:token?/:slug?",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: ActivationPage,
    },
  },
  {
    name: "sbkResendActivation",
    path: "/sbk/resend-activation/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: SbkLogin,
    },
  },
  {
    name: "sbkPasswordResetStart",
    path: "/sbk/reset",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: PasswordReset,
    },
  },
  {
    name: "sbkPasswordReset",
    path: "/sbk/reset/:token/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: PasswordResetSet,
    },
  },
  {
    name: "sbkLogin",
    path: "/sbk/login/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: SbkLogin,
    },
  },
  {
    name: "sbkSite",
    path: "/sbk/site/:name",
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: SbkSite,
    },
  },
  {
    name: "contact",
    path: "/:slug/contact",
    components: {
      default: ContactPage,
    },
    meta: {},
  },
  {
    name: "imprint",
    path: "/:slug/imprint",
    components: {
      default: ImprintPage,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "privacy",
    path: "/:slug/privacy",
    components: {
      default: PrivacyPage,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "privacyFallback",
    path: "/privacy",
    components: {
      default: privacyFallback,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "termsOfService",
    path: "/:slug/terms",
    components: {
      default: termsOfService,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "termsOfServiceFallback",
    path: "/terms",
    components: {
      default: termsOfServiceFallback,
    },
    meta: {
      isPublic: true,
    },
  },
  {
    name: "maintenancePage",
    path: "/maintenance",
    meta: {
      isPublic: true,
      noHeader: true,
    },
    components: {
      default: Maintenance,
    },
  },
  {
    name: "feed",
    path: "/:slug/feed",
    components: {
      default: FeedPage,
    },
    meta: {},
  },
  {
    name: "challenges",
    path: "/:slug/challenges",
    components: {
      default: ChallengePage,
    },
    meta: {},
  },
  {
    name: "challengesHistory",
    path: "/:slug/challenges/history",
    components: {
      default: HistoryPage,
    },
    meta: {},
  },
  {
    name: "customChallengeDetail",
    path: "/:slug/challenge/:challengeId",
    components: {
      default: CustomChallengeDetailPage,
    },
    meta: {},
  },
  {
    name: "competitiveChallengeDetail",
    path: "/:slug/team-challenge/:challengeId",
    components: {
      default: CompetitiveChallengeDetailPage,
    },
    meta: {},
  },
  {
    name: "challengeStatistics",
    path: "/:slug/statistics/:challengeId",
    components: {
      default: statisticsPage,
    },
    meta: {},
  },
  {
    name: "competitiveChallengeStatistics",
    path: "/:slug/team-statistics/:challengeId",
    components: {
      default: statisticsPage,
    },
    meta: {},
  },
  {
    name: "competitiveChallengeJoinTeam",
    path: "/:slug/team-challenge/join-team/:challengeId",
    components: {
      default: CompetitiveChallengeJoinTeamPage,
    },
    meta: {},
  },
  {
    name: "articlesByCategory",
    path: "/:slug/articles/category/:category/:name",
    meta: {},
    components: {
      default: ArticlesPage,
    },
  },
  {
    name: "articlesByType",
    path: "/:slug/articles/type/:type",
    meta: {},
    components: {
      default: ArticlesPage,
    },
  },
  {
    name: "article",
    path: "/:slug/article/:id",
    meta: {},
    components: {
      default: ArticlePage,
    },
  },
  {
    name: "favorites",
    path: "/:slug/favorites",
    components: {
      default: FavoritePage,
    },
  },
  {
    path: "/locked-screen",
    name: "LockedScreen",
    components: {
      default: LockedScreenPage,
    },
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
  },
  {
    path: "/:slug/settings",
    name: "settings",
    components: {
      default: SettingsPage,
    },
    meta: {},
  },
];

if (import.meta.env.DEV) {
  routes.push({
    path: "/:slug/pattern-library",
    name: "PatternLibrary",
    components: {
      default: PlaygroundPage,
    },
  });
}

const lockedMode = false;

const lockedRoute = [
  {
    path: "/:pathMatch(.*)*",
    name: "LockedScreen",
    components: {
      default: LockedScreenPage,
    },
    meta: {
      hideNavigation: true,
      isPublic: true,
      noHeader: true,
    },
  },
  {
    name: "sbkRegister",
    path: "/sbk/register/:atmCampaign",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: skbRegister,
    },
  },
  {
    name: "sbkRegisterSuccess",
    path: "/sbk/register/:atmCampaign/success",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: SbkRegisterSuccessPage,
    },
  },
  {
    name: "sbkActivate",
    path: "/sbk/activate/:token?/:slug?",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: ActivationPage,
    },
  },
  {
    name: "sbkResendActivation",
    path: "/sbk/resend-activation/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: SbkLogin,
    },
  },
  {
    name: "sbkPasswordResetStart",
    path: "/sbk/reset",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: PasswordReset,
    },
  },
  {
    name: "sbkPasswordReset",
    path: "/sbk/reset/:token/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: PasswordResetSet,
    },
  },
  {
    name: "sbkLogin",
    path: "/sbk/login/:atmCampaign?",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: SbkLogin,
    },
  },
  {
    name: "sbkSite",
    path: "/sbk/site/:name",
    meta: {
      hideNavigation: true,
      isPublic: true,
    },
    components: {
      default: SbkSite,
    },
  },
];

export default lockedMode ? lockedRoute : routes;
